import React from 'react';
import { ArrowLeft, MoreHorizontal, Navigation2, MapPin, Clock, CircleDot, Baby, MessageCircle, PhoneCall } from 'lucide-react';
import { Link } from 'react-router-dom';
import RouteMap from '../components/RouteMap';
import './CarpoolDesignPrototype.css';

/** Demo route (Sofia) for the static /design-prototype screen */
const DEMO_ORIGIN = { lat: 42.6977, lng: 23.3219 };
const DEMO_DEST = { lat: 42.655, lng: 23.311 };
const DEMO_WAYPOINTS = [{ id: 'demo', lat: 42.682, lng: 23.324 }];

const CarpoolDesignPrototype = () => {
  return (
    <div className="carpool-modern-root carpool-modern-root--standalone design-prototype-wrapper">
      <div className="carpool-modern-shell">
        <div className="dribbble-map-header">
          <div className="dribbble-map-header__map">
            <RouteMap variant="hero" origin={DEMO_ORIGIN} destination={DEMO_DEST} waypoints={DEMO_WAYPOINTS} />
          </div>
          <div className="glass-nav-bar">
            <Link to="/dashboard" className="glass-btn">
              <ArrowLeft size={20} />
            </Link>
            <button type="button" className="glass-btn" aria-label="More">
              <MoreHorizontal size={20} />
            </button>
          </div>
          <div className="map-fade-overlay" />
        </div>

        <div className="dribbble-bottom-sheet">
          <div className="sheet-header">
            <div className="sheet-badge">Active Route</div>
            <h1 className="sheet-title">Училище „Св. Климент“</h1>
            <p className="sheet-subtitle">
              <Clock size={14} /> Взимане днес, 07:30
            </p>
          </div>

          <div className="sheet-participants">
            <div className="avatar-stack">
              <img src="https://i.pravatar.cc/100?img=47" className="dribbble-avatar" alt="Driver" />
              <img src="https://i.pravatar.cc/100?img=45" className="dribbble-avatar" alt="Parent 2" />
              <img src="https://i.pravatar.cc/100?img=12" className="dribbble-avatar" alt="Parent 3" />
              <div className="dribbble-avatar more-avatar">+2</div>
            </div>
            <div className="participant-info">
              <h3>Вие сте шофьор</h3>
              <p>5-ма в групата</p>
            </div>
            <div className="action-circle">
               <MessageCircle size={18} />
            </div>
          </div>

          <div className="dribbble-timeline">
            
            <div className="d-timeline-item">
              <div className="d-node">
                 <div className="d-icon-wrapper start"><CircleDot size={18} strokeWidth={3} /></div>
                 <div className="d-line"></div>
              </div>
              <div className="d-content">
                <p className="d-time">07:30</p>
                <div className="d-card">
                  <h4>Вашият адрес</h4>
                  <p>Начална точка</p>
                </div>
              </div>
            </div>

            <div className="d-timeline-item">
              <div className="d-node">
                 <div className="d-icon-wrapper waypoint"><Baby size={16} strokeWidth={2.5} /></div>
                 <div className="d-line"></div>
              </div>
              <div className="d-content">
                <p className="d-time">07:38</p>
                <div className="d-card highlight">
                  <h4>Вземане на Алекс</h4>
                  <p>ул. Александър Малинов 14</p>
                  <div className="d-card-actions">
                     <button className="d-mini-btn call"><PhoneCall size={12}/> Обади се</button>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-timeline-item">
              <div className="d-node">
                 <div className="d-icon-wrapper waypoint"><Baby size={16} strokeWidth={2.5} /></div>
                 <div className="d-line"></div>
              </div>
              <div className="d-content">
                <p className="d-time">07:45</p>
                <div className="d-card highlight">
                  <h4>Вземане на Мишо</h4>
                  <p>ж.к. Младост 3, бл. 302</p>
                </div>
              </div>
            </div>

            <div className="d-timeline-item">
              <div className="d-node">
                 <div className="d-icon-wrapper end"><MapPin size={18} strokeWidth={2.5} /></div>
              </div>
              <div className="d-content">
                <p className="d-time">08:00</p>
                <div className="d-card">
                  <h4>Училище „Св. Климент“</h4>
                  <p>Крайна точка</p>
                </div>
              </div>
            </div>

          </div>

          <div className="dribbble-sheet-footer">
            <button type="button" className="dribbble-main-btn">
              <Navigation2 size={20} />
              Старт навигация
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarpoolDesignPrototype;
